// extracted by mini-css-extract-plugin
module.exports = {"paymentsCards":"payments-page_paymentsCards__IgHV2","paymentsEmptyData":"payments-page_paymentsEmptyData__132KV","loader":"payments-page_loader__3YVc5"};